import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchResults = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Hook for navigation
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const query = new URLSearchParams(location.search).get('query'); // Get the search query from URL

  useEffect(() => {
    const fetchSearchResults = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`/api/bible/search?query=${encodeURIComponent(query)}`);
        const data = await response.json();
        setSearchResults(data);
      } catch (error) {
        console.error('Failed to fetch search results:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (query) {
      fetchSearchResults();
    }
  }, [query]);

  const handleResultClick = (result) => {
    // Navigate to BibleDisplay route with version, book, and chapter
    console.log("where to go",result.version, result.book, result.chapter)
    navigate(`/bible/${result.version}/${result.book}/${result.chapter}`);
  };

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Search Results for "{query}"</h2>
      {isLoading && <p>Loading...</p>}
      {!isLoading && searchResults.length === 0 && (
        <p>No results found for "{query}".</p>
      )}
      <div className="grid grid-cols-1 gap-4">
        {searchResults.map((result) => (
          <div
            key={result.id}
            className="border p-4 rounded shadow hover:bg-gray-100 transition cursor-pointer"
            onClick={() => handleResultClick(result)} // Navigate on click
          >
            <p className="font-bold">
              {result.book} {result.chapter}:{result.verse} ({result.version})
            </p>
            <p>{result.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchResults;
